const SOCIALS = [
  { id: "link", url: "https://www.connoroflocke.com" },
  { id: "email", url: "mailto:clocke555@gmail.com" },
  { id: "github", url: "https://github.com/ConnorOfLocke" },
  { id: "linkedIn", url: "https://www.linkedin.com/in/connor-locke-warburton-a8287890/" },
  { id: "bluesky", url: "https://bsky.app/profile/spiggleedoo.bsky.social" },
];

export default SOCIALS;
